/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const particle_chain_about = () => `Particle Network radically simplifies Web3’s user experience through Wallet Abstraction and Chain Abstraction. Through its Wallet Abstraction SDKs, developers can enable one-click onboarding into smart accounts through social logins. Furthermore, Particle Network’s Chain Abstraction stack, with Universal Accounts as a flagship product, enables users to have a unified account and balance across every chain.`
